import React, { useMemo, useEffect, useState } from "react";
import { Tooltip } from "antd";
import { observer } from "mobx-react"; // Import observer
import Chat from "components/Conversation/Chat";
import styles from "./phoneframe.module.scss";

const PhoneFrame = observer(props => {
  const {
    headerName = "GUNI SMS",
    messageList,
    showMessageBox = false,
    currentMessageContent,
    handleInputChange,
    handleSend,
    containerStyle,
    sender,
    isMms = false,
    phoneFrameImageUrl,
    smallFrame = false,
    selectedData
  } = props;

  const [renderKey, setRenderKey] = useState(0);

  useEffect(() => {
    setRenderKey(prev => prev + 1);
  }, [sender, headerName, selectedData?.sender]);

  const displayHeaderName = useMemo(() => {
    if (selectedData?.sender && selectedData.sender !== "GUNI SMS") {
      return selectedData.sender;
    }
    if (sender && sender !== "GUNI SMS") {
      return sender;
    }
    if (headerName && headerName !== "GUNI SMS") {
      return headerName;
    }
    return "GUNI SMS";
  }, [selectedData?.sender, sender, headerName, renderKey]);

  return (
    <div key={renderKey} className={smallFrame ? styles.containerSmall : styles.container} style={containerStyle}>
      <div className={styles.headerName}>
        <h5 className="fw-900 d-flex justify-content-center">
          {displayHeaderName}
          {(sender || selectedData?.sender) && (
            <Tooltip title={`Sender ID: ${selectedData?.sender || sender}`} placement="top">
              <div>
                <i className="fas fa-info-circle text-info-color ms-2" />
              </div>
            </Tooltip>
          )}
        </h5>
      </div>
      <Chat
        messageList={messageList}
        currentMessageContent={currentMessageContent}
        showMessageBox={showMessageBox}
        handleInputChange={handleInputChange}
        handleSend={handleSend}
        chatBoxClass={styles.chatBox}
        isMms={isMms}
        phoneFrameImageUrl={phoneFrameImageUrl}
      />
    </div>
  );
});

export default PhoneFrame;
